import ApiService from '@/services/core/api.service'

const SharedSSOService = {
  async post (payload) {
    return ApiService.post('auth/sso/oauth2', payload)
  }
}

export default SharedSSOService
